import { tourCrudConfig, type Tour } from '@/config/objects/tours';
import {
  CrudListView,
  type CrudConfig,
  type CrudListHeaderAction,
} from '@startupquickstart/frontend';
interface ToursListProps {
  /**
   * Optional custom config (with modified endpoints, actions, etc.)
   */
  config?: CrudConfig<Tour>;
  /**
   * Optional default where clause for filtering
   */
  defaultWhere?: Record<string, unknown>;

  /**
   * Custom class name for the container
   */
  className?: string;
  /**
   * Base URL for navigation, defaults to /tours
   */
  baseUrl?: string;
  /**
   * Custom buttons rendered in the list header alongside (or in place of)
   * the standard Add/Create buttons. Use this to inject context-specific
   * actions like "Add tours to hotel".
   */
  headerActions?: CrudListHeaderAction[];
}

/**
 * Reusable tours list component
 * Pass a custom config with modified actions to customize behavior
 */
export function ToursList({
  config,
  baseUrl = '/tours',
  defaultWhere,
  className,
  headerActions,
}: ToursListProps) {
  return (
    <div className={className}>
      <CrudListView
        config={config || tourCrudConfig}
        baseUrl={baseUrl}
        defaultWhere={defaultWhere}
        headerActions={headerActions}
        getValueFromItem={(tour: Tour) => tour.id}
        getLabelFromItem={(tour: Tour) => tour.name}
      />
    </div>
  );
}
